import React, { useState } from 'react';
import { Link } from "react-router-dom";

import { url } from '../../inv';

import { generalS } from '../../strings/general';

export default function LatestProject({ windowWidth, language, lpObjs }) {
  return(
    <div className={"home-calender-content"}>
      <div className={"col"}>
        {lpObjs && lpObjs.col1?
          lpObjs.col1.map((l, i) => {
            if (i > 2) return;
            return(
              <div data-aos="fade-up" className={"home-card"}>
                <div className={"home-card-img"}>
                  <img src={`${url}/public/${l.fileNames[0]}`} />
                </div>
                <div className={"home-card-text-content"}>
                  <div style={{width: "100%", 
                    display: "flex", 
                    justifyContent: "center", 
                    margin: "24px 0 24px 0"}}>
                    <p className={"home-card-title"}>{l.data.value.title}</p>
                  </div>
                  <h3 style={{ width: "100%" }}>{l.data.value.subTitle}</h3>
                  <p className={"home-card-detail"}>{l.data.value.details[0]}</p>
                </div>
                <div className={"home-card-link-content"}>
                  <Link to={`/detail?${l.postId}`} className={"home-card-link"}>
                    {generalS.readMore[language]}
                  </Link>
                </div>
              </div>
            )
          })
        :("")}
      </div> 
      <div className={"col"}>
        {lpObjs && lpObjs.col2?
          lpObjs.col2.map((l, i) => {
            if (i > 2) return;
            return(
              <div className={"home-card"}>
                <div className={"home-card-img"}>
                  <img src={`${url}/public/${l.fileNames[0]}`} />
                </div>
                <div className={"home-card-text-content"}>
                  <div style={{width: "100%", 
                    display: "flex", 
                    justifyContent: "center", 
                    margin: "24px 0 24px 0"}}>
                    <p className={"home-card-title"}>{l.data.value.title}</p>
                  </div>
                  <h3 style={{ width: "100%" }}>{l.data.value.subTitle}</h3>
                  <p className={"home-card-detail"}>{l.data.value.details[0]}</p>
                </div>
                <div className={"home-card-link-content"}>
                  <Link to={`/detail?${l.postId}`} className={"home-card-link"}>
                    {generalS.readMore[language]}
                  </Link>
                </div>
              </div>
            )
          })
        :("")}
      </div>
      <div className={"col"}>
        {lpObjs && lpObjs.col3?
          lpObjs.col3.map((l, i) => {
            if (i > 2) return;
            return(
              <div data-aos="fade-up" className={"home-card"}>
                <div className={"home-card-img"}>
                  <img src={`${url}/public/${l.fileNames[0]}`} />
                </div>
                <div className={"home-card-text-content"}>
                  <div style={{width: "100%", 
                    display: "flex", 
                    justifyContent: "center", 
                    margin: "24px 0 24px 0"}}>
                    <p className={"home-card-title"}>{l.data.value.title}</p>
                  </div>
                  <h3 style={{ width: "100%" }}>{l.data.value.subTitle}</h3>
                  <p className={"home-card-detail"}>{l.data.value.details[0]}</p>
                </div>
                <div className={"home-card-link-content"}>
                  <Link to={`/detail?${l.postId}`} className={"home-card-link"}>
                    {generalS.readMore[language]}
                  </Link>
                </div>
              </div>
            )
          })
        :("")}
      </div>
    </div>
  )
}
